<div #searchPiesHeader class="outerContainer">
	<search-results-header
		*ngIf="!shouldShowNewCategoriesList && (breakPointService.device$ | async) !== device.MOBILE && heading"
		[dasFacets]="dasFacets"
		[dasFacetsRoute]="dasFacetsRoute"
		[dasFacetsQueryParams]="dasFacetsQueryParams"
		[shouldShowNewCategoriesList]="shouldShowNewCategoriesList"
		[heading]="heading"
		[totalItems]="totalItems"
		[currentShelf]="currentShelf"
></search-results-header>

	<ng-container [class.hideDynamicContentPanel]="!showDynamicContent">
		<ng-content select="[dynamic-content]"></ng-content>
	</ng-container>

	<section class="boostOffer" *ngIf="boostOfferTag?.redemption">
		<p class="boostOffer-description">
			{{ boostOfferTag?.description?.detailed }}
		</p>
		<div class="boostOffer-expiry">
			<span><b>Offer expiry:</b></span>
			<span>{{ expiryDate }}</span>
		</div>
		<div class="boostOffer-limit">
			<span><b>Offer limit:</b></span>
			<span>{{ maxRedemptionQuantity }}</span>
		</div>
		<span class="boostOffer-used" *ngIf="redeemedCount > 0">
			{{ redeemedCount }} offer{{ redeemedCount > 1 ? 's' : '' }} bought
		</span>
	</section>

	<div
		class="filterGroupContainer"
		[ngClass]="{
			showSwitchToggle: enableSwitchToggleShowInStock && !enableHideSwitchToggleForOOS
		}"
	>
		<section
			class="innerContainer"
			*ngIf="(breakPointService.device$ | async) !== device.MOBILE && myFilterGroups && myFilterGroups.length"
		>
			<label *ngIf="!shouldShowNewCategoriesList">Filter by:</label>
			<search-filter-group
				[group]="filterGroup"
				[selectedFilters]="selectedFilters"
				*ngFor="let filterGroup of myFilterGroups"
			>
			</search-filter-group>
		</section>

		<ng-container *ngIf="!(shouldShowNewCategoriesList && (breakPointService.device$ | async) === device.MOBILE)">
			<form-dropdown
				name="sortby-dropdown"
				[labelText]="!shouldShowNewCategoriesList ? 'Sort by:' : ''"
				[list]="sortOptions"
				(onSelect)="handleSortChange($event)"
				[selectedValue]="currentSortOption"
			></form-dropdown>
		</ng-container>
	</div>

	<div class="selectedFilterAndSwitchContainer">
		<ng-container *ngIf="(breakPointService.device$ | async) !== device.MOBILE">
			<search-filter-tags
				*ngIf="selectedFilters.length"
				[filters]="selectedFilters"
				(removeFilter)="onRemoveFilter($event)"
				(removeAllFilters)="onRemoveAllFilters()"
				class="searchFilterTags"
			></search-filter-tags>
		</ng-container>

		<section class="switchToggleGroup" *ngIf="enableSwitchToggleShowInStock && !enableHideSwitchToggleForOOS">
			<span class="newCoachmark" *ngIf="isNewCoachmarkVisible"> NEW </span>
			<form-switch
				class="formSwitch"
				size="small"
				[checked]="inStockProductsOnlyToggleState"
				(switchChange)="handleInStockProductsOnlyToggle($event)"
				>Show in stock items only</form-switch
			>
		</section>
	</div>
</div>
